@import '../../helpers/helpers';


.input {
  margin: 8px 0;
  padding: 0.6em 1em 0.55em;
  width: 100%;
  background-color: #eee;
  border: 2px solid #eee;
  border-radius: 0.25em;
  outline: none;
  cursor: default;

  &:focus {
    cursor: auto;
  }

  &::placeholder {
    font-style: italic;
  }

  &.error {
    border-color: #f00;
  }
}